import { useEffect } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

export const DocVisible = () => {
  const { projectId } = useParams()
  const queryClient = useQueryClient()

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState == 'visible') {
        queryClient.invalidateQueries({ queryKey: ['project', projectId] })
      }
    }

    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [projectId, queryClient])

  return false
}
